export default __webpack_public_path__ + "static/media/14-sync-drift.f7e60f15.jpg";